import { cva } from 'class-variance-authority';

const buttonVariants = cva(
  'disabled:bg-text-disabled disabled:text-text-muted inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-md text-lg whitespace-nowrap transition-all outline-none disabled:pointer-events-none',
  {
    variants: {
      variant: {
        default:
          'bg-primary-100 hover:bg-primary-100/90 text-neutral-100 active:bg-base-orange-20',
        primary:
          'bg-primary-100 hover:bg-base-orange-30 active:bg-base-orange-20 text-neutral-100',
        table: 'bg-secondary-10 hover:bg-secondary-30 text-secondary-100',
        secondary:
          'bg-primary-10 text-primary-100 hover:bg-base-orange-100 hover:text-base-orange-10 active:bg-base-orange-80',
        destructive:
          'bg-base-red-100 text-base-red-20 hover:bg-base-red-90 hover:text-base-red-10 active:bg-base-red-80',
        outline:
          'border border-border-default bg-neutral-100 shadow-xs hover:bg-neutral-80 hover:text-text-secondary dark:bg-input/30 dark:border-input dark:hover:bg-input/50 text-text-primary',
        ghost: 'hover:bg-neutral-90 text-text-primary dark:hover:bg-accent/50',
        link: 'text-text-link underline-offset-4 hover:underline',
        green: 'bg-green-100 text-base-green-10 hover:bg-green-200',
        yellow:
          'bg-base-yellow-100 text-base-yellow-10 hover:bg-base-yellow-90',
      },
      size: {
        default: 'px-4 py-2 text-lg [&>svg]:size-5',
        lg: 'px-4 py-2 text-lg [&>svg]:size-5',
        md: 'px-4 py-2 text-base [&>svg]:size-4',
        sm: 'px-2 py-2 text-sm [&>svg]:size-3',
        icon: 'size-9',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

export { buttonVariants };
